import { useAdminPreferencesStore } from '@/store/admin-preferences.store';
import { useEffect } from 'react';

export function useTheme() {
  const { theme, setTheme } = useAdminPreferencesStore();

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return { theme, setTheme, toggleTheme };
}
